import { User, Home, Building2, Bot, EyeOff } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export const getProfileIcon = (profileType: string): LucideIcon => {
    switch (profileType) {
        case 'household': return Home;
        case 'organization': return Building2;
        case 'bot': return Bot;
        case 'pseudonymous': return EyeOff;
        default: return User;
    }
};

export const getInitials = (name: string): string => {
    const parts = name.trim().split(/\s+/);
    if (parts.length >= 2) {
        return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
};

export const getProfileColor = (_profileId: string, index: number): string => {
    const hue = (index * 137.508) % 360;
    return `hsl(${hue}, 70%, 55%)`;
};

export function getToolIdFromPath(pathname: string): string | undefined {
    if (pathname.startsWith('/habits')) return 'habits';
    if (pathname.startsWith('/meal-planner')) return 'meal-planner';
    if (pathname.startsWith('/calendar')) return 'calendar';
    if (pathname.startsWith('/docs')) return 'docs';
    if (pathname.startsWith('/community-votes')) return 'community-votes';
    return undefined;
}
